module.exports = __webpack_public_path__ + "static/media/7.05fc49db.svg";